import React, { useEffect } from "react";

import { Select } from "antd";

import { connect } from "react-redux";

import {
  setSourceOfFund,
  getAllowedSourceOfFunds,
  cleanup,
} from "rx/selectsourceoffund";

function SelectSourceOfFundRxComponent(props) {
  useEffect(() => {
    props.getAllowedSourceOfFunds();
  }, []);

  return (
    <>
      <Select
        {...props}
        size="large"
        value={props.sourceOfFund}
        onChange={(sourceOfFund) => props.setSourceOfFund(sourceOfFund)}
      >
        {props.allowedSourceOfFunds &&
          props.allowedSourceOfFunds.map((record) => {
            return (
              <Select.Option value={record.code} key="idx">
                {record.value}
              </Select.Option>
            );
          })}
      </Select>
    </>
  );
}

const mapStateToProps = (state) => {
  return {
    sourceOfFund: state.selectSourceOfFund.sourceOfFund,
    allowedSourceOfFunds: state.selectSourceOfFund.allowedSourceOfFunds,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    cleanup: () => dispatch(cleanup()),
    setSourceOfFund: (sourceOfFund) => dispatch(setSourceOfFund(sourceOfFund)),
    getAllowedSourceOfFunds: () => dispatch(getAllowedSourceOfFunds()),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SelectSourceOfFundRxComponent);
